import React, { useState, useRef, useEffect } from "react";
import "./Chatbot.css";

const Chatbot = () => {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [typing, setTyping] = useState(false);
  const [showHint, setShowHint] = useState(true);
  const messagesEndRef = useRef(null);

const BACKEND_BASE_URL = process.env.REACT_APP_BACKEND_URL;

  const suggestedQuestions = [
    "Where does Redi work?",
    "What is his work experience",
    "Show Redi's CV",
    "What skills does Redi have?",
    "Which projects has Redi done?"
  ];

  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages, typing]);

  useEffect(() => {
    const timer = setTimeout(() => setShowHint(false), 5000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (open && messages.length === 0) {
      setMessages([
        {
          sender: "Assistant",
          text: "Hello! I'm Redi Ibra's assistant. You can ask me questions about him."
        }
      ]);
    }
  }, [open]);

  const handleSend = async (manualInput) => {
    const trimmed = (manualInput || input).trim();
    if (!trimmed) return;

    setMessages((prev) => [...prev, { sender: "You", text: trimmed }]);
    setInput("");
    setTyping(true);

    try {
      const res = await fetch(`${BACKEND_BASE_URL}/chat`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ message: trimmed }),
      });

      if (!res.ok) throw new Error("Server error");

      const data = await res.json();
      let replyText = typeof data.reply === "string" ? data.reply : JSON.stringify(data.reply);

      // CV download
      if (replyText === "__DOWNLOAD_CV__") {
        window.open(`${BACKEND_BASE_URL}/download-cv`, "_blank");
        replyText = "Here is the CV download link. ✅";
      }

      setMessages((prev) => [...prev, { sender: "Assistant", text: replyText }]);
    } catch (err) {
      setMessages((prev) => [
        ...prev,
        {
          sender: "Assistant",
          text: "The server is busy or your requests are too fast. Please try again in a few seconds."
        }
      ]);
      console.error(err);
    } finally {
      setTyping(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") handleSend();
  };

  return (
    <div className="chatbot-container">
      {open && (
        <div className="chatbot-box">
          <div className="chatbot-messages">
            {messages.map((msg, idx) => (
              <div
                key={idx}
                className={`chatbot-message ${msg.sender === "You" ? "user" : "bot"}`}
              >
                <strong>{msg.sender}:</strong> {msg.text}
              </div>
            ))}
            {typing && (
              <div className="chatbot-message bot">
                <em>Assistant is typing...</em>
              </div>
            )}
            <div ref={messagesEndRef}></div>
          </div>

          <div className="chatbot-suggestions-scroll">
            {suggestedQuestions.map((q, idx) => (
              <span
                key={idx}
                className="chatbot-suggestion"
                onClick={() => handleSend(q)}
              >
                {q}
              </span>
            ))}
          </div>

          <div className="chatbot-input-container">
            <input
              type="text"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyPress={handleKeyPress}
              placeholder="Type a message..."
              className="chatbot-input"
            />
            <button onClick={() => handleSend()} className="chatbot-send">Send</button>
          </div>
        </div>
      )}

      <div style={{ position: "relative" }}>
        <button className="chatbot-toggle" onClick={() => setOpen(!open)}>?</button>

        {showHint && (
          <div className="chatbot-hint">
            <span>👋 You can ask me questions about Redi!</span>
            <div className="chatbot-hint-arrow"></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Chatbot;
